import { connectHook } from 'app/common/components/connect-hook';
import { Search } from './search';
import { useSearch } from './search-hook';

export default connectHook(Search, useSearch);
